
export default {
  data() {
    return {
      loading: true,
      timer: null,
      mutationObserver: null
    };
  },
  mounted() {
    this.startLoadingTimeout();
    this.observeMutations();
  },
  methods: {
    startLoadingTimeout() {
      this.timer = setTimeout(() => {
        this.loading = false;
        this.cleanUp();
      }, 2600);
    },
    observeMutations() {
      const existingInsNodes = document.querySelectorAll("ins.adsbygoogle");
      if (existingInsNodes.length > 0) {
        this.loading = false;
        this.cleanUp();
      } else {
        this.mutationObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.target.matches("ins.adsbygoogle")) {
              this.loading = false;
              this.cleanUp();
            }
          });
        });

        this.mutationObserver.observe(document.documentElement, {
          childList: true,
          subtree: true
        });
      }
    },
    cleanUp() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
        this.mutationObserver = null;
      }
    }
  }
};
